import axios from 'axios';

import { UserDto } from './user.interface';

class UserService {
  async getUser(): Promise<UserDto> {
    const response = await axios.get('user/me');
    return response.data as UserDto;
  }
}

export default new UserService();
